angular.module('admin.directives')

.directive('addEditBillingInfo', ['RecurlyTokenService', '$timeout', 'AgentService', 'ScrollService', 'UtilService',
function(RecurlyTokenService, $timeout, AgentService, ScrollService, utils){

    return {
      restrict: 'E',
      controllerAs: 'addEditBillingInfoCtrl',
      bindToController: {
        agent: '=',
        onCancel: '&',
        onSave: '&',
      },
      scope: {},
      templateUrl: '/admin/templates/partials/add-edit-billing-info.html',

      controller: function(){
        let ctrl = this;

        ctrl.submit = function(){
          ctrl.error = '';
          ctrl.loading = true;
          utils.track('BillingCreditCardSubmit');

          RecurlyTokenService.fetchToken(ctrl.htmlFormElement)
            .then((token) => {
              return AgentService.createRecurlyAccount(ctrl.agent.id, token);
            })
            .then(success)
            .catch(error);
        };

        ctrl.cancel = function(){
          ctrl.onCancel();
        }

        function success(){
          ScrollService.scroll({target: 'billingFormTop'});
          ctrl.loading = false;
          ctrl.onSave();
        }

        function error(e){
          ScrollService.scroll({target: 'billingFormTop'});
          ctrl.loading = false;
          ctrl.error = e.message ? e.message : e;
          utils.trackException('Billing Credit Card Submit', ctrl.error);
        }
      },

      link: function($scope, el, attrs, ctrl){
        ctrl.htmlFormElement = el[0].querySelector('form');

        $timeout(initRecurly, 0); // ensure html element is ready in dom

        function initRecurly(){
          recurly.configure({
            style: {
              all: {
                fontColor: '#FC5AA6',
                fontFamily: 'Open Sans',
                fontSize: '1.6rem',
              },
              input: {
                borderColor: 'transparent',
                backgroundColor: 'rgba(255,255,255,.05)',
              },
              number: {
                placeholder: ''
              },
              month: {
                placeholder: 'MM'
              },
              year: {
                placeholder: 'YY'
              }
            }
          });

          recurly.on('field:submit', ctrl.submit);
        }
      }
    }

  }]);
